
import NotificationContextProvider from './NotificationContext';
import LanguageContextProvider from './LanguageContext';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import ptBr from 'dayjs/locale/pt-br';


const MainContextProvider = (props: React.PropsWithChildren) => {
    return (
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={ptBr}>
            <LanguageContextProvider>
                <NotificationContextProvider>
                    {props.children}
                </NotificationContextProvider>
            </LanguageContextProvider>
        </LocalizationProvider>
    );
}


export default MainContextProvider;